import React, { Component } from "react";
import Table from "../common/Table";
import SearchForm from "./TemporarySearchForm";

export default class TemporaryRegists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      searchConditions: {},
      lastPage: 1,
      currentPage: 1,
      from: "",
      to: "",
      total: "",
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  /**
   * Get search data
   */
  handleSearch(key) {
    this.setState({
      searchConditions: key,
    });
    axios.post("/api/accounts/temporary/search", key).then((response) => {
      this.setState({
        accounts: response.data.data,
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
      });
      this.props.history.push({
        search: $.param(key),
      });
    });
  }

  /**
   * Init data and form client or list accounts
   */
  componentWillMount() {
    const keySearch_str = this.props.location.search.substring(1);
    let keySearch_arr = { page: 1 };
    if (keySearch_str) {
      keySearch_arr = JSON.parse(
        '{"' +
          decodeURI(keySearch_str.replace(/&/g, '","').replace(/=/g, '":"')) +
          '"}'
      );
    }

    //always get list data
    axios.post("/api/accounts/temporary/search", keySearch_arr).then((response) => {
      this.setState({
        accounts: response.data.data,
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        searchConditions: keySearch_arr,
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
      });
      this.props.history.push({
        search: keySearch_str,
      });
    });
  }

  /**
   * Sort data
   */
  handleSort(key) {
    //add sort params to search conditions
    let newSearchConditions = this.state.searchConditions;
    newSearchConditions.sort_column = key.sort_column;
    newSearchConditions.sort_type = key.sort_type;
    this.setState({
      searchConditions: newSearchConditions,
    });
    axios.post("/api/accounts/temporary/search", newSearchConditions).then((response) => {
      this.setState({
        accounts: response.data.data,
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
      });
      this.props.history.push({
        search: $.param(newSearchConditions),
      });
    });
  }

  /**
   * Handle redirect
   */
  handleRedirect(e) {
    e.preventDefault();
    this.props.history.push(e.currentTarget.getAttribute("href"));
  }

  render() {
    const columns = [
      { name: "id", title: "ID", isSort: 1, type: "text" },
      { name: "is_houjin", title: "種別", isSort: 1, type: "text" },
      { name: "created_at", title: "登録日時", isSort: 1, type: "date_time" },
      {
        name: "confirmed_at",
        title: "メール認証完了日時",
        isSort: 1,
        type: "date_time",
      },
      {
        name: "tel",
        title: "電話番号",
        isSort: 1,
        type: "text_limit",
        isSearch: true,
      },
      {
        name: "email",
        title: "メールアドレス",
        isSort: 1,
        type: "text_limit",
        isSearch: true,
      },
      {
        name: "sms_auth_status",
        title: "SMS認証",
        isSort: 1,
        type: "option",
        option: {
          1: {
            text: "認証済",
            classHTML: "text-teal"
          },
          0: {
            text: "未認証",
            classHTML: "text-gray"
          },
          null: {
            text: "未認証",
            classHTML: "text-gray"
          },
        },
      },
      {
        name: "sms_verified_at",
        title: "SMS認証完了日時",
        isSort: 1,
        type: "date_time",
      },
      {
        name: "passcode",
        title: "認証コード",
        isSort: 1,
        type: "text_limit",
        isSearch: true,
      },
    ];
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/home">
                    ダッシュボード
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  仮登録者一覧
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <main id="main">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h4 className="mt-2 mb-0 page-title">仮登録者一覧</h4>
                    </div>
                    <div className="col text-right">
                      <button
                        className="btn btn-light"
                        type="button"
                        data-toggle="collapse"
                        data-target="#search_client"
                        aria-expanded="false"
                        aria-controls="search_client"
                      >
                        絞込検索
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <SearchForm onSearch={this.handleSearch} />
                    </div>
                  </div>
                </div>
                <Table
                  onSearch={this.handleSearch}
                  header={columns}
                  data={this.state.accounts}
                  onSort={this.handleSort}
                  from={this.state.from}
                  to={this.state.to}
                  total={this.state.total}
                  myPagination={1}
                  searchConditions={this.state.searchConditions}
                  lastPage={this.state.lastPage}
                  currentPage={this.state.currentPage}
                />
              </div>
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
